import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';

import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../../hooks';

export const IngredientCardQuantityStepperContainer = (
  props: IngredientCardQuantityStepperContainerProps,
) => {
  const { children, style, size = 'sm', nativeID } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const wrapperResponsiveStyles = match([null, null, null, styles.wrapperXL]);
  const wrapperStyles = [styles.wrapper, wrapperResponsiveStyles, style];
  const innerContainerStyles = [
    styles.innerContainer,
    size === 'sm' ? styles.innerContainerSM : undefined,
    size === 'md' ? styles.innerContainerMD : undefined,
  ];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={wrapperStyles} pointerEvents="box-none">
      <View style={innerContainerStyles} pointerEvents="auto" nativeID={nativeID}>
        {children}
      </View>
    </View>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
  },
  wrapperXL: {
    paddingHorizontal: theme.spacing['2'],
  },
  innerContainer: {
    minWidth: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['3'],
    borderRadius: theme.radius.xxlarge,
    justifyContent: 'space-between',
    backgroundColor: theme.colors.CREAM,
    padding: theme.spacing['1'],
    ...theme.elevations['4'],
  },
  innerContainerSM: {
    borderRadius: theme.radius.xxlarge,
  },
  innerContainerMD: {
    borderRadius: 60,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type IngredientCardQuantityStepperContainerProps = {
  children: React.ReactNode;
  size?: 'sm' | 'md';
  style?: ViewProps['style'];
  nativeID?: string;
};
